<div id="error-404" fxLayout="column" fxLayoutAlign="center center">

    <div class="content" fxLayout="column" fxLayoutAlign="center center">

        <div class="error-code">{{(data$ | async).code}}</div>

        <div class="message">{{(data$ | async).title}}</div>
        <br/>

        <div class="sub-message">
            {{(data$ | async).message}}
        </div>
        <br/>
        <a class="back-link" [routerLink]="'/'">Retour à l'accueil</a>

    </div>

</div>